<template>
  <div class="grade-admin">
    <el-table class="customTable" :data="examList"
              style="width: 100%; margin-top: 20px; flex: 1;border: 1px solid #EEEEEE;" height="1%" size="medium"
              :header-cell-style="{fontWeight: 'normal', height: '60px', color: '#666666', background: '#F6F6F6',fontSize: '16px'}"
              :cell-style="{fontSize: '16px',color: '#333333',height: '70px'}">
      <el-table-column prop="name" align="left" label="考试名称"></el-table-column>
      <el-table-column prop="user_name" align="center" label="创建人"></el-table-column>
      <el-table-column prop="begin_time" align="center" label="考试时间"></el-table-column>
      <el-table-column prop="exam_num" label="考试人数" align="center"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-link type="success" :underline="false" @click="viewDetail(scope.row)">批改</el-link>
<!--          <el-link type="primary" :underline="false" @click="viewDetail(scope.row.exam_id,1)">已批改（{{scope.row.submitted}}）</el-link>-->
<!--          <el-link type="success" :underline="false" @click="viewDetail(scope.row.exam_id,2)">待批改（{{scope.row.marked}}）</el-link>-->
<!--          <el-link type="danger" :underline="false" @click="viewDetail(scope.row.exam_id,3)">未提交（{{scope.row.no_submitted}}）</el-link>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager-center" style="margin: 20px;text-align: center"
                   :current-page="listPages.currentPageNum"
                   :page-size="listPages.eachPageNum"
                   :total="listPages.total"
                   layout="prev, pager, next, jumper"
                   @current-change="listCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {examGradingManagementList} from '@/utils/apis'
export default {
  name: "Index",
  data() {
    return {
      examList:[],
      listPages:{
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0,
      },
    }
  },
  mounted() {
    this.getExamList()
  },
  methods: {
    getExamList(){
      let params = {
        paging:1,
        page:this.listPages.currentPageNum,
        pageSize:this.listPages.eachPageNum
      }
      examGradingManagementList(params).then((res)=>{
        this.examList = res.data.data;
        this.listPages.total = res.data.total;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    listCurrentChange(val){
      this.listPages.currentPageNum = val;
      this.getExamList();
    },
    viewDetail(row) {
      if(row.is_click === 1){
        this.$router.push({
          path: '/judges/theoreticalQuestions',
          query:{
            examId:row.exam_id
          }
        })
      } else {
        this.$message.warning('该考试没有主观题，无需批改！')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.grade-admin {
  padding: 0px 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>